/**
 * The "Run" switch (`header.modes.run`, 2.E deliverable 8): beside the page modes of a session
 * document, a link to `/run/$sessionId`. Nothing at all with `flag:sessions` off or on any other
 * document.
 */
import './run-switch.css';
import { docsMeta, flagsFromMe, type SlotComponentProps, tid } from '@codex/contracts';
import { Icon } from '@codex/ui';
import { useQuery } from '@tanstack/react-query';
import { api } from '../auth/client.js';
import { useGoTo } from '../shell/open-doc.js';
import { metaKey } from '../shell/queries.js';
import { useShellSession } from '../shell/session.js';

export const runHref = (sessionId: string) => `/run/${sessionId}`;

export function RunSwitch({ docId }: SlotComponentProps) {
  const me = useShellSession();
  const enabled = me !== null && flagsFromMe(me).sessions === true;
  return enabled ? <RunSwitchFor docId={docId} /> : null;
}

function RunSwitchFor({ docId }: { docId: string }) {
  const goTo = useGoTo();
  const meta = useQuery({
    queryKey: metaKey(docId),
    queryFn: () => api(docsMeta, { params: { id: docId } }),
  });
  if (meta.data?.typeKey !== 'session') return null;
  const href = runHref(docId);
  return (
    <a
      className="cx-run-switch"
      href={href}
      onClick={(event) => goTo(href, event)}
      {...tid('run.header.switch')}
    >
      <Icon name="play" size={16} />
      Run
    </a>
  );
}
